<nav class="navbar navbar-expand-lg navbar-dark fixed-top">
    <div class="container">
        <a class="navbar-brand" href="#">Brand</a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarContent">
            <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
                <li class="nav-item">
                    <a class="nav-link" [routerLinkActive]="['active']" [routerLink]="['/products-list']">Home</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [routerLinkActive]="['active']" [routerLink]="['/products']">Products</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [routerLinkActive]="['active']"
                     matBadge="4" matBadgeOverlap="false" [routerLink]="['/cart']">Cart<sup><span>{{totalLength}}</span></sup></a>
                </li>
            </ul>
            <ul class="navbar-nav">
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false"> Account </a>
                    <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown">
                        <li><a class="dropdown-item" [routerLink]="['/my-favourite']">My Favourites</a></li>
                        <li><a class="dropdown-item" href="#">Logout</a></li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
</nav>